<template>
    <div class="record">
        <div class="record-bg"></div>
        <div class="record-nav">
            <img @click="goBack" class="arrow-icon" src="../../assets/img/me/icon9.png" alt="" />
            <span>{{ $t('record.record') }}</span>
            <div class="record-icon"></div>
        </div>
        <div class="placeholder"></div>
        <div class="px20">
            <div class="tabs">
                <div :class="{ active: active == 1 }" @click="active = 1">{{ $t('record.all') }}</div>
                <div :class="{ active: active == 2 }" @click="active = 2">{{ $t('record.recharge') }}</div>
                <div :class="{ active: active == 3 }" @click="active = 3">{{ $t('record.transfer') }}</div>
                <div :class="{ active: active == 4 }" @click="active = 4">{{ $t('record.claimed') }}</div>
            </div>

            <div class="record-item" v-for="i in 5">
                <div>
                    <div class="record-item-t">
                        <div>{{ $t('record.recharge') }}</div>
                        <div>+ 23.47 YUX</div>
                    </div>
                    <div class="record-item-b">2025/10/29 00:00:00
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
    Popover
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";
import QRCode from 'qrcode'

export default {
    name: "record",
    components: {
        Popover,
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "",
            dd: 0.0,
            qrcodeUrl: '',
            showPopover: false,
            active: 1
        };
    },
    computed: {},
    mounted() {

    },
    methods: {
        goBack() {
            this.$router.back()
        },
        go(path) {
            this.$router.push(path)
        }
    },
};
</script>

<style lang="less" scoped>
.record {
    position: relative;
    overflow: auto;
    flex: 1;
    height: 100%;
    background-size: 100% 800px;
    padding: 0 0 42px;
    background: url("../../assets/img/home/header-bg.png") no-repeat;
    background-size: 471.9px 240.62px;
    background-position: -60px -97px;
    display: flex;
    flex-direction: column;

    &-bg {
        width: 375px;
        position: absolute;
        height: 200px;
        background: url('../../assets/img/me/header-bg.png') no-repeat center;
        top: -44px;
        background-size: 100% 100%;
    }

    &-nav {
        position: fixed;
        top: 0;
        max-width: 375px;
        width: 100%;
        padding: 10px 20px 10px 19px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 16px;

        .arrow-icon {
            width: 24px;
            height: 24px;
        }

        .record-icon {
            width: 20px;
            height: 20px;
        }
    }

    .placeholder {
        height: 44px;
    }

    .px20 {
        padding: 0 20px;
    }

    .tabs {
        position: relative;
        z-index: 2;
        margin-top: 28px;
        display: flex;
        align-items: center;
        font-size: 16px;
        line-height: 16px;

        >div+div {
            margin-left: 32px;
        }

        >div {
            padding-bottom: 8px;
            opacity: 0.5;
            position: relative;
            &.active {
                opacity: 1;
                font-weight: bold;
                &::before {
                    content: ' ';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 2px;
                    background: linear-gradient(94deg, #0DF1D5 0%, #0190D1 97%);
                }
            }
        }
    }

    .record-item {
        z-index: 2;
        position: relative;

        margin-top: 20px;
        border-radius: 16px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
           background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
        height: 72px;
        padding: 16px;
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            .record-item-t {
                display: flex;
                justify-content: space-between;
                font-weight: 500;
                font-size: 16px;
                line-height: 16px;
            }

            .record-item-b {
                margin-top: 12px;
                line-height: 12px;
                color: #999999;
                font-size: 12px;
            }
        }
    }


}
</style>
<style lang="less">
.record {
    .ipt {
        height: 48px;
        padding: 16px;

        .van-cell {
            padding: 0;
            background-color: transparent;
        }
    }
}
</style>